export default __webpack_public_path__ + "static/1-667a02a3fae45cfd44957041563f8c40.webp";